import { render, staticRenderFns } from "./carCharge-add.vue?vue&type=template&id=daafebc2&"
import script from "./carCharge-add.vue?vue&type=script&lang=js&"
export * from "./carCharge-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports